const PageHeader = ({ title, description, eyebrow, actions, children }) => (
  <header className="sa-page-header">
    <div>
      {eyebrow ? <span className="sa-page-header__eyebrow">{eyebrow}</span> : null}
      <h1>{title}</h1>
      {description ? <p>{description}</p> : null}
    </div>
    {actions ? <div className="sa-page-header__actions">{actions}</div> : null}
    {children}
  </header>
);

export default PageHeader;
